var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Window',{attrs:{"active":_vm.active},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('ChartReadme',{staticClass:"chart-container",attrs:{"version-info":_vm.versionInfo}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }